import { hasConsent } from './cookieConsent';

/**
 * Fire a Facebook Pixel event, gated on marketing consent.
 * No-ops server-side, before fbq is loaded, or before consent is granted.
 */
export const trackFbEvent = (eventName, params) => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function' || !hasConsent('marketing'))
    return;
  window.fbq('track', eventName, params);
};
